      document.addEventListener('DOMContentLoaded', function() {
  // Alle collection-card__info-tigger Elemente finden
  const infoTriggers = document.querySelectorAll('.collection-card__info-tigger');
  
  // Event-Listener für jeden Trigger hinzufügen
  infoTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      // Das Elternelement (js-collection-item) finden
      const collectionItem = this.closest('.js-collection-item');
      
      // Das content Element und tigger-link Element innerhalb des aktuellen collection-item finden
      const contentElement = collectionItem.querySelector('.collection-card__info');
      const triggerLinkElement = this.querySelector('.collection-card__info-tigger-link');
      
      // Prüfen ob die Elemente gefunden wurden
      if (contentElement && triggerLinkElement) {
        // Toggle der active Klasse (hinzufügen falls nicht vorhanden, entfernen falls vorhanden)
        contentElement.classList.toggle('active');
        triggerLinkElement.classList.toggle('active');
      }
      
      // Optional: Alle anderen active Klassen entfernen, wenn ein neues Element angeklickt wird
      // Dies schließt alle anderen geöffneten Elemente
      infoTriggers.forEach(function(otherTrigger) {
        if (otherTrigger !== trigger) {
          const otherCollectionItem = otherTrigger.closest('.js-collection-item');
          const otherContentElement = otherCollectionItem.querySelector('.collection-card__info');
          const otherTriggerLinkElement = otherTrigger.querySelector('.collection-card__info-tigger-link');
          
          if (otherContentElement && otherContentElement.classList.contains('active')) {
            otherContentElement.classList.remove('active');
          }
          
          if (otherTriggerLinkElement && otherTriggerLinkElement.classList.contains('active')) {
            otherTriggerLinkElement.classList.remove('active');
          }
        }
      });
    });
  });
});